import { createContext } from 'react';

export const AppointmentContext = createContext();
export const AvailableAppointmentsContext = createContext();
export const UserContext = createContext();
export const VwoContext = createContext();
export const CardscanContext = createContext();